import { IIconProps } from "../types"

export default function IconLR1(props: IIconProps) {
  const width = props.size || props.width || 50
  const height = props.size || props.height || 86
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 50 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6973 1.43153C18.7273 0.811533 28.7473 0.491533 34.8373 0.451533C40.9273 0.421533 43.0673 0.681533 44.5673 1.33153C46.0673 1.98153 46.9073 3.02153 47.5973 4.26153C48.2773 5.50153 48.7973 6.93153 49.0573 9.47153C49.3173 12.0115 49.3173 15.6515 49.1573 21.9715C48.9973 28.2915 48.6673 37.2715 47.5273 47.0015C46.3873 56.7415 44.4373 67.2215 42.9373 73.3715C41.4473 79.5215 40.3973 81.3515 38.2573 82.6115C36.1073 83.8815 32.8473 84.6015 29.3673 84.8315C25.8873 85.0615 22.1773 84.8015 19.3373 84.1115C16.5073 83.4315 14.5573 82.3215 13.1273 81.0515C11.6873 79.7815 10.7773 78.3515 8.85732 71.1215C6.93732 63.9015 4.00732 50.8815 2.47732 42.1215C0.947318 33.3615 0.817318 28.8715 0.657318 23.9215C0.497318 18.9715 0.297318 13.5715 0.627318 10.1515C0.947318 6.74153 1.79732 5.30153 3.22732 4.13153C4.65732 2.96153 6.67732 2.05153 12.6973 1.43153Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
